import { createStyles } from '@material-ui/core';
export var styles = function styles(theme) {
  return createStyles({
    menu: {
      backgroundColor: theme.palette.background.default,
      boxShadow: theme.shadows[2],
      fontSize: 14,
      transition: 'all 0.3s',
      width: 250,
      overflow: 'auto',
      maxHeight: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      '& > $list > $item > $link': {
        margin: '0 8px'
      }
    },
    min: {
      width: 66,
      '& $link': {
        padding: '12px 5px',
        justifyContent: 'center'
      },
      '& $toggle': {
        padding: '12px 2px',
        position: 'relative',
        margin: '0 8px'
      },
      '& $icon': {
        marginRight: 0,
        minWidth: 34
      },
      '& $label': {
        height: 17,
        opacity: 0,
        display: 'none'
      },
      '& $caret': {
        position: 'absolute',
        right: 4,
        fontSize: 16
      },
      '& $version': {
        fontSize: 9
      }
    },
    list: {
      padding: '8px 0',
      '& $list': {
        paddingLeft: 8,
        paddingRight: 8,
        '& $link': {
          padding: '9px 15px',
          minHeight: 38,
          fontSize: 13
        },
        '& $icon': {
          transform: 'scale(0.8)'
        }
      }
    },
    item: {
      color: theme.palette.secondary.dark
    },
    link: {
      alignItems: 'center',
      color: 'inherit',
      display: 'flex',
      minHeight: 44,
      overflow: 'hidden',
      padding: '12px 15px',
      textDecoration: 'none',
      transition: 'all 0.3s'
    },
    active: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[1],
      color: '#fff'
    },
    toggle: {
      alignItems: 'center',
      color: 'inherit',
      display: 'flex',
      minHeight: 44,
      overflow: 'hidden',
      padding: '10px 15px',
      textDecoration: 'none',
      transition: 'all 0.3s',
      cursor: 'pointer',
      margin: '0 8px'
    },
    caret: {
      width: 24,
      transition: 'all 0.3s',
      marginRight: -10
    },
    icon: {
      fontSize: 0,
      marginRight: 10,
      textAlign: 'center'
    },
    label: {
      minWidth: 150,
      flexGrow: 1
    },
    submenu: {
      overflow: 'hidden',
      transition: 'all 0.3s ease',
      backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.12), transparent 15%, transparent 85%, rgba(0, 0, 0, 0.12))'
    },
    hidden: {
      '& $submenu': {
        height: 0,
        borderBottom: 0,
        marginBottom: 0,
        paddingBottom: 0
      },
      '& $caret': {
        transform: 'rotate(180deg)'
      }
    },
    version: {
      color: '#212121',
      fontSize: 13,
      textAlign: 'center',
      paddingBottom: 16,
      transition: 'all .2s ease',
      padding: '0 5px'
    }
  });
};